const WidgetType = {
    Baskets: 1,
    UserSearches: 2,
    Distributions: 3,
    UploadedDocumentsChart: 4,
    DocumentsByContentTypeChart: 5,
    DocumentsByWorkflowChart: 6,
    Bookmark: 7,
    Note: 8,
    SearchHistory: 9,
    Newsfeed: 10,
    DocumentTracker: 11
}
export default WidgetType
